import script from "./ConnectionRibbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectionRibbon.vue?vue&type=script&lang=ts&setup=true"

import "./ConnectionRibbon.vue?vue&type=style&index=0&id=676aebfd&lang=scss"

const __exports__ = script;

export default __exports__